import React from 'react'

const ThumbnailPhoto = ({ src }) => {
  if (src) {
    return (
      <div className="bg-black-4 py-16 pr-16 lg:p-0 lg:mr-1 flex-shrink-0">
        <img
          className="w-100-fixed sm:w-180-fixed lazyloaded"
          alt=""
          src={src}
        />
      </div>
    )
  } else {
    return (
      <div className="hidden lg:block w-180-fixed bg-black-4 mr-1 flex-shrink-0" />
    )
  }
}

export default ThumbnailPhoto
